<template>
  <div>
    <v-col cols="12">
      <v-row align="center" justify="center" class="mb-3">
        <div class="pa-3">
          <v-btn
            text
            @click="downloadFile('docx')"
            class="primary--text text-none font-weight-bold"
          >
            <v-icon
              v-if="!loadingDocx"
              aria-hidden="true"
              aria-label="Descargar archivo en formato Word"
              large
              color="primary"
              class="pr-1"
              >fas fa-file-word</v-icon
            >
            <v-progress-circular
              v-else
              indeterminate
              color="primary"
            ></v-progress-circular
            >Descargar DOC
          </v-btn>
        </div>
        <div class="pa-3">
          <v-btn
            text
            @click="downloadFile('csv')"
            class="primary--text text-none font-weight-bold"
          >
            <v-icon
              v-if="!loadingCsv"
              aria-hidden="true"
              aria-label="Descargar archivo en formato CSV"
              large
              color="primary"
              class="pr-1"
              >fas fa-file-csv</v-icon
            >
            <v-progress-circular
              v-else
              indeterminate
              color="primary"
            ></v-progress-circular
            >Descargar CSV
          </v-btn>
        </div>
      </v-row>
    </v-col>
  </div>
</template>

<script>
import axios from "../config/axios";
import Notifier from "./Notifier";
import { mapGetters } from "vuex";

export default {
  components: { Notifier },
  data() {
    return {
      loadingDocx: false,
      loadingCsv: false,
      consulted: false,
      message: "",
    };
  },
  computed: {
    ...mapGetters("process", [
      "getSearch",
      "getPaginacionProcesos",
      "getOnlyActive",
      "getIdProceso",
      "getLlaveProceso",
      "getInDetails",
    ]),
  },
  methods: {
    downloadFile(type) {
      let url = null;
      let name = null;
      const now = new Date();
      const date = `${now.getFullYear()}${
        now.getUTCMonth() + 1
      }${now.getUTCDate()}`;
      const time = `${now.getHours()}${now.getMinutes()}${now.getSeconds()}`;

      if (!this.getInDetails) {
        if (type == "docx") this.loadingDocx = true;
        else this.loadingCsv = true;

        name = `Procesos_${date}_${time}`;
        url = `/Descarga/${type.toUpperCase()}/Procesos/${this.getSearch}`;
      } else {
        if (type == "docx") this.loadingDocx = true;
        else this.loadingCsv = true;
        let idProceso = this.getIdProceso;
        name = `Proceso_${this.getLlaveProceso}_${date}_${time}`;
        url = `/Descarga/${type.toUpperCase()}/${
          type == "docx" ? "Proceso" : "Detalle"
        }/${idProceso}`;
      }

      if (url) {
        axios({
          url,
          method: "GET",
          responseType: "blob",
        })
          .then((response) => {
            let fileURL = window.URL.createObjectURL(new Blob([response.data]));
            let fileLink = document.createElement("a");

            fileLink.href = fileURL;
            fileLink.setAttribute("download", `${name}.${type}`);
            document.body.appendChild(fileLink);

            fileLink.click();
            this.loadingDocx = false;
            this.loadingCsv = false;
          })
          .catch((err) => {
            this.loadingDocx = false;
            this.loadingCsv = false;
            this.consulted = true;

            this.$store.dispatch("process/notificarDocumentoNoDisponible");
            //this.$store.dispatch(err);
          });
      }
    },
  },
};
</script>
